import React from 'react';
import FolioManagement from '../components/Configuracion/FolioManagement';

const FolioManagementPage = () => {
  return <FolioManagement />;
};

export default FolioManagementPage;
